import { Refresh as RefreshIcon } from '@mui/icons-material';
import { format, parseISO } from 'date-fns';
import { GENERATE_NEW_CODES, NO_BACKUP_CODES_AVAILABLE } from 'common/constants/auth';
import { Button, LoadingState } from 'components/ui';
import type { BackupCodesStatusSummaryProps } from './BackupCodesStatusSummary.props';
import { StyledStatusLine, StyledSummaryContainer } from './BackupCodesStatusSummary.styles';
import { BACKUP_CODES_STATUS_SUMMARY_TEST_IDS } from './BackupCodesStatusSummary.testIds';

const BackupCodesStatusSummary = ({
  status,
  isLoading = false,
  isGeneratingBackupCodes = false,
  disabledGenerate = false,
  onGenerateNewCodes,
}: BackupCodesStatusSummaryProps) => {
  if (isLoading) {
    return <LoadingState minHeight={80} />;
  }

  const codesRemaining = status?.codes_remaining ?? 0;
  const hasCodes = codesRemaining > 0;

  return (
    <StyledSummaryContainer data-testid={BACKUP_CODES_STATUS_SUMMARY_TEST_IDS.root}>
      <StyledStatusLine data-testid={BACKUP_CODES_STATUS_SUMMARY_TEST_IDS.codesRemaining}>
        {hasCodes
          ? `${codesRemaining} of ${status?.codes_total} backup codes remaining`
          : NO_BACKUP_CODES_AVAILABLE}
      </StyledStatusLine>

      {status?.last_generated_at ? (
        <StyledStatusLine data-testid={BACKUP_CODES_STATUS_SUMMARY_TEST_IDS.generatedOn}>
          {`Generated on ${format(parseISO(status.last_generated_at), 'MMM d, yyyy')}`}
        </StyledStatusLine>
      ) : null}

      <Button
        data-testid={BACKUP_CODES_STATUS_SUMMARY_TEST_IDS.generateButton}
        disabled={disabledGenerate || isGeneratingBackupCodes}
        loading={isGeneratingBackupCodes}
        onClick={onGenerateNewCodes}
        sizeVariant="compact"
        startIcon={<RefreshIcon />}
        variant="outlined"
        visualVariant="primaryOutline"
      >
        {GENERATE_NEW_CODES}
      </Button>
    </StyledSummaryContainer>
  );
};

export default BackupCodesStatusSummary;
